import { render, staticRenderFns } from "./LayoutTypeIcon.vue?vue&type=template&id=6e24e116&scoped=true"
import script from "./LayoutTypeIcon.vue?vue&type=script&lang=js"
export * from "./LayoutTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./LayoutTypeIcon.vue?vue&type=style&index=0&id=6e24e116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24e116",
  null
  
)

export default component.exports